React = require 'react'
t = require('views/internal/recup-with-helpers')('multi_board_guest_banner')
localizeCount = require 'lib/localize-count'
formatMoney = require 'lib/format/money'

class MultiBoardGuestBannerComponent extends React.Component
  displayName: 'MultiBoardGuestBanner'

  render: t.renderable ->

    {
      effectiveDate
      multiBoardGuests
      price
      interval
      teamUrl
      onDismissBanner
    } = @props

    count = localizeCount 'multi-board-guests', multiBoardGuests
    amount = formatMoney price * multiBoardGuests
    url = "#{teamUrl}/members"

    t.div '.multi-board-guest-banner', =>
      t.button '.icon-lg.icon-close', onClick: onDismissBanner
      t.div '.multi-board-guest-banner-content', =>
        t.div '.multi-board-guest-banner-notification-section', =>
          t.p =>
            if multiBoardGuests > 0
              if interval == 'yearly'
                t.format "notification-with-guests-per-year", { effective_date: effectiveDate, url, count, amount }
              else
                t.format "notification-with-guests-per-month", { effective_date: effectiveDate, url, count, amount }
            else
              t.format "notification-without-guests", { effective_date: effectiveDate, url, count, amount }
        t.div '.multi-board-guest-banner-button-section', =>
          if multiBoardGuests > 0
            t.a '.primary.button-link.multi-board-guest-banner-button-manage', { href: url }, =>
              t.format 'manage-guests'
          t.a '.button-link.multi-board-guest-banner-button-learn-more', { href: 'https://help.trello.com/article/1123-multi-board-guests', target: '_blank' } , =>
            t.format 'learn-more'

module.exports = MultiBoardGuestBannerComponent



// WEBPACK FOOTER //
// ./app/scripts/views/organization/multi-board-guest-banner-component.coffee